"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "@/components/ui/Link";
import { useRouter } from "next/navigation";
import LiveBlink from "@/components/ui/LiveBlink";
import { isLiveBlogValue } from "@/lib/liveBlog";
import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getTimeAgo, getFocusPointStyle, toFieldString, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string | boolean;
  customClass?: string;
};
type Props = {
  category?: FieldConfig;
  sectionUrl?: string;
  title?: FieldConfig;
  excerpt?: FieldConfig;
  timeAgo?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  /** Mark as LCP image - preloads for faster rendering */
  priority?: boolean;
  imageMetadata?: ImageMetadata;
  templatetype?: FieldConfig;
  isliveblog?: FieldConfig;
};
export default function HorizontalSmallRightImageCategoryNews(t0) {
  const $ = _c(70);
  const {
    category: t1,
    sectionUrl,
    title: t2,
    excerpt: t3,
    timeAgo: t4,
    imageSrc: t5,
    slug,
    priority: t6,
    imageMetadata,
    templatetype: t7,
    isliveblog: t8
  } = t0;
  let t9;
  if ($[0] !== t1) {
    t9 = t1 === undefined ? {
      hidden: false,
      value: "BUSINESS",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t9;
  } else {
    t9 = $[1];
  }
  const category = t9;
  let t10;
  if ($[2] !== t2) {
    t10 = t2 === undefined ? {
      hidden: false,
      value: "\u0BAE\u0BC6\u0B9F\u0BCD\u0BB0\u0BCB\u0BB5\u0BBF\u0BB2\u0BCD \u0BAE\u0BC6\u0B9F\u0BCD\u0BB0\u0BCB \u0B9A\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BAE\u0BCD \u0BA4\u0BCB\u0BA9\u0BCD\u0BB1\u0BC1\u0BAE\u0BCD \u0BAE\u0BA3\u0BBF; \u0B86\u0B95\u0BB8\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD \u0BA4\u0BCA\u0B9F\u0B95\u0BCD\u0B95\u0BAE\u0BCD",
      customClass: ""
    } : t2;
    $[2] = t2;
    $[3] = t10;
  } else {
    t10 = $[3];
  }
  const title = t10;
  let t11;
  if ($[4] !== t3) {
    t11 = t3 === undefined ? {
      hidden: false,
      value: "\u0B9A\u0BC6\u0BA9\u0BCD\u0BA9\u0BC8 \u0BAE\u0BC6\u0B9F\u0BCD\u0BB0\u0BCB\u0BB5\u0BBF\u0BB2\u0BCD \u0BAE\u0BC6\u0B9F\u0BCD\u0BB0\u0BCB \u0B9A\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BAE\u0BCD \u0BA4\u0BCB\u0BA9\u0BCD\u0BB1\u0BC1\u0BAE\u0BCD \u0BAE\u0BA3\u0BBF \u0B86\u0B95\u0BB8\u0BCD\u0B9F\u0BC1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD \u0BA4\u0BCA\u0B9F\u0B99\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BC1\u0BAE\u0BCD \u0B8E\u0BA9 \u0BAE\u0BC6\u0B9F\u0BCD\u0BB0\u0BCB \u0BB0\u0BAF\u0BBF\u0BB2\u0BCD \u0BA8\u0BBF\u0BB0\u0BCD\u0BB5\u0BBE\u0B95\u0BAE\u0BCD \u0BA4\u0BC6\u0BB0\u0BBF\u0BB5\u0BBF\u0BA4\u0BCD\u0BA4\u0BA4\u0BC1",
      customClass: ""
    } : t3;
    $[4] = t3;
    $[5] = t11;
  } else {
    t11 = $[5];
  }
  const excerpt = t11;
  const timeAgo = t4 === undefined ? {
    hidden: false,
    value: "Wed, 17 May 2023",
    customClass: ""
  } : t4;
  const imageSrc = t5 === undefined ? {
    hidden: false,
    value: FALLBACK_IMAGE,
    customClass: ""
  } : t5;
  const priority = t6 === undefined ? false : t6;
  let t12;
  if ($[6] !== t7) {
    t12 = t7 === undefined ? {
      hidden: false,
      value: "",
      customClass: ""
    } : t7;
    $[6] = t7;
    $[7] = t12;
  } else {
    t12 = $[7];
  }
  const templatetype = t12;
  let t13;
  if ($[8] !== t8) {
    t13 = t8 === undefined ? {
      hidden: false,
      value: "",
      customClass: ""
    } : t8;
    $[8] = t8;
    $[9] = t13;
  } else {
    t13 = $[9];
  }
  const isliveblog = t13;
  const router = useRouter();
  const t14 = category?.value;
  let t15;
  if ($[10] !== t14) {
    t15 = toFieldString(t14);
    $[10] = t14;
    $[11] = t15;
  } else {
    t15 = $[11];
  }
  const categoryValue = t15;
  const t16 = title?.value;
  let t17;
  if ($[12] !== t16) {
    t17 = toFieldString(t16);
    $[12] = t16;
    $[13] = t17;
  } else {
    t17 = $[13];
  }
  const titleValue = t17;
  const t18 = excerpt?.value;
  let t19;
  if ($[14] !== t18) {
    t19 = toFieldString(t18);
    $[14] = t18;
    $[15] = t19;
  } else {
    t19 = $[15];
  }
  const excerptValue = t19;
  const timeAgoValue = getTimeAgo(toFieldString(timeAgo?.value));
  const imageSrcValue = getImageUrl(toFieldString(imageSrc?.value)) || FALLBACK_IMAGE;
  let t20;
  if ($[16] !== isliveblog?.value || $[17] !== templatetype?.value) {
    t20 = isLiveBlogValue(templatetype?.value) || isLiveBlogValue(isliveblog?.value);
    $[16] = isliveblog?.value;
    $[17] = templatetype?.value;
    $[18] = t20;
  } else {
    t20 = $[18];
  }
  const isLiveBlog = t20;
  let t21;
  if ($[19] !== router || $[20] !== sectionUrl) {
    t21 = e => {
      if (sectionUrl) {
        e.preventDefault();
        e.stopPropagation();
        router.push(sectionUrl);
      }
    };
    $[19] = router;
    $[20] = sectionUrl;
    $[21] = t21;
  } else {
    t21 = $[21];
  }
  const handleCategoryClick = t21;
  let t22;
  if ($[22] !== imageMetadata || $[23] !== imageSrc?.customClass || $[24] !== imageSrc?.hidden || $[25] !== imageSrcValue || $[26] !== priority || $[27] !== titleValue) {
    t22 = !imageSrc?.hidden && <div className={`relative w-[106px] h-[76px] lg:w-[134px] lg:h-[134px] flex-shrink-0 overflow-hidden ${imageSrc?.customClass || ""}`}><Image src={imageSrcValue} alt={titleValue} width={134} height={134} priority={priority} className="object-cover w-full h-full !h-[76px] lg:!h-[134px]" style={getFocusPointStyle(imageMetadata)} sizes="(min-width: 1024px) 134px, 106px" loading={priority ? "eager" : "lazy"} fetchPriority={priority ? "high" : "auto"} placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /></div>;
    $[22] = imageMetadata;
    $[23] = imageSrc?.customClass;
    $[24] = imageSrc?.hidden;
    $[25] = imageSrcValue;
    $[26] = priority;
    $[27] = titleValue;
    $[28] = t22;
  } else {
    t22 = $[28];
  }
  let t23;
  if ($[29] !== category?.customClass || $[30] !== category?.hidden || $[31] !== categoryValue || $[32] !== handleCategoryClick || $[33] !== sectionUrl) {
    t23 = !category?.hidden && <>{sectionUrl ? <span className={`text-11-tamil-600 text-012061 tracking-wide uppercase hover:underline cursor-pointer ${category?.customClass || ""}`} onClick={handleCategoryClick}>{categoryValue}</span> : <div className={`text-11-tamil-600 text-012061 tracking-wide uppercase ${category?.customClass || ""}`}>{categoryValue}</div>}</>;
    $[29] = category?.customClass;
    $[30] = category?.hidden;
    $[31] = categoryValue;
    $[32] = handleCategoryClick;
    $[33] = sectionUrl;
    $[34] = t23;
  } else {
    t23 = $[34];
  }
  let t24;
  if ($[35] !== isLiveBlog || $[36] !== title?.customClass || $[37] !== title?.hidden || $[38] !== titleValue) {
    t24 = !title?.hidden && <h3 className={`text-1B1B1B text-14-tamil-700 font-medium leading-[1.4] ${title?.customClass || ""}`}>{isLiveBlog && <LiveBlink />}{titleValue}</h3>;
    $[35] = isLiveBlog;
    $[36] = title?.customClass;
    $[37] = title?.hidden;
    $[38] = titleValue;
    $[39] = t24;
  } else {
    t24 = $[39];
  }
  let t25;
  if ($[40] !== excerpt?.customClass || $[41] !== excerpt?.hidden || $[42] !== excerptValue) {
    t25 = !excerpt?.hidden && <p className={`text-4D4D4D text-12-tamil-400 leading-[1.3] line-clamp-2 ${excerpt?.customClass || ""}`}>{excerptValue}</p>;
    $[40] = excerpt?.customClass;
    $[41] = excerpt?.hidden;
    $[42] = excerptValue;
    $[43] = t25;
  } else {
    t25 = $[43];
  }
  let t26;
  if ($[44] !== t23 || $[45] !== t24 || $[46] !== t25) {
    t26 = <div className="flex flex-col gap-2">{t23}{t24}{t25}</div>;
    $[44] = t23;
    $[45] = t24;
    $[46] = t25;
    $[47] = t26;
  } else {
    t26 = $[47];
  }
  let t27;
  if ($[48] !== timeAgo?.customClass || $[49] !== timeAgo?.hidden || $[50] !== timeAgoValue) {
    t27 = !timeAgo?.hidden && <span className={`text-12-tamil-500 text-1B1B1B ${timeAgo?.customClass || ""}`}>{timeAgoValue}</span>;
    $[48] = timeAgo?.customClass;
    $[49] = timeAgo?.hidden;
    $[50] = timeAgoValue;
    $[51] = t27;
  } else {
    t27 = $[51];
  }
  const t28 = slug ? `/${slug}` : undefined;
  let t29;
  if ($[52] !== excerptValue || $[53] !== imageSrcValue || $[54] !== slug || $[55] !== t28 || $[56] !== titleValue) {
    t29 = <MessageIcon id="right-image-news-message-icon" slug={slug} category={BOOKMARK_CATEGORIES.NEWS} title={titleValue} thumbnailUrl={imageSrcValue} description={excerptValue} articleUrl={t28} />;
    $[52] = excerptValue;
    $[53] = imageSrcValue;
    $[54] = slug;
    $[55] = t28;
    $[56] = titleValue;
    $[57] = t29;
  } else {
    t29 = $[57];
  }
  let t30;
  if ($[58] !== t27 || $[59] !== t29) {
    t30 = <div className="flex items-center justify-between">{t27}{t29}</div>;
    $[58] = t27;
    $[59] = t29;
    $[60] = t30;
  } else {
    t30 = $[60];
  }
  let t31;
  if ($[61] !== t26 || $[62] !== t30) {
    t31 = <div className="flex flex-col justify-between gap-2 w-full">{t26}{t30}</div>;
    $[61] = t26;
    $[62] = t30;
    $[63] = t31;
  } else {
    t31 = $[63];
  }
  let t32;
  if ($[64] !== t22 || $[65] !== t31) {
    t32 = <article className="p-4"><div className="flex flex-row-reverse gap-3">{t22}{t31}</div></article>;
    $[64] = t22;
    $[65] = t31;
    $[66] = t32;
  } else {
    t32 = $[66];
  }
  const content = t32;
  if (slug) {
    const t33 = `/${slug}`;
    let t34;
    if ($[67] !== content || $[68] !== t33) {
      t34 = <Link href={t33} className="block  transition-colors cursor-pointer">{content}</Link>;
      $[67] = content;
      $[68] = t33;
      $[69] = t34;
    } else {
      t34 = $[69];
    }
    return t34;
  }
  return content;
}